module.exports = __webpack_public_path__ + "static/media/D2.d3c5a7ac.png";